"use client";
import { FC } from "react";
import { CHAR_LIMITS, textEllipsis } from "./clpCardConstant";
import { PriceChange } from "./PriceChange";
import { PriceDisplay } from "./PriceDisplay";
import { StockLogo } from "./StockLogo";
import { StockContentProps } from "./types";

export const StockContent: FC<StockContentProps> = ({
  stock,
  defaultImage,
  onModalStateChange,
  modalTitle,
  modalBtnCta,
  successMsg,
  errorMsg,
  cta_text,
   section_title,
  hidePriceChange = false,
}) => {
  const { perChange, logoURL, symbol, ltp, changePrice } = stock;
  const isPositive = Number(perChange) >= 0;

  return (
    <div className="flex flex-col gap-3 w-full cursor-pointer rounded-lg">
      <div className="flex w-full flex-col gap-2">
        <div className="flex w-full flex-col">
          <StockLogo
            logoURL={logoURL}
            defaultImage={defaultImage}
            symbol={symbol}
            stock={stock}
            onModalStateChange={onModalStateChange}
            modalTitle={modalTitle}
            modalBtnCta={modalBtnCta}
            successMsg={successMsg}
            errorMsg={errorMsg}
            cta_text={cta_text}
            section_title={section_title}
          />
        </div>

        <h2 className="stock-symbol overflow-hidden text-[14px] font-normal leading-[1.179] text-[#1a1a1a] sm:text-[16px] sm:leading-[1.031]">
          {textEllipsis(
            symbol?.toUpperCase() || "symbol",
            CHAR_LIMITS.STOCK_TITLE,
            "stock-symbol",
          )}
        </h2>
      </div>

      <div className="flex flex-col gap-1">
        <PriceDisplay ltp={ltp} isPositive={isPositive} />
        {!hidePriceChange && (
          <PriceChange changePrice={changePrice} perChange={perChange} />
        )}
      </div>
    </div>
  );
};

